import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { Overview } from "../../../../../../types/types";

import { CandidateDetails } from "../../../../types/candidate";
import { CandidateOverviewCard } from "../../../../components";
import {
  AgeIcon,
  FormationsIcon,
  TeamsCoachedIcon,
  CountriesCoachedInIcon,
} from "../../../../assets/icons/candidate-details-page-icons";

const CoachOverview = ({ candidateDetails }: { candidateDetails: CandidateDetails }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "candidateDetailsPage.overviewTab" });

  const getIcon = (key: string): JSX.Element | null => {
    switch (key) {
      case "age":
        return <AgeIcon />;
      case "preferredFormations":
        return <FormationsIcon />;
      case "totalTeamsCoached":
        return <TeamsCoachedIcon />;
      case "countriesCoachedIn":
        return <CountriesCoachedInIcon />;
      default:
        return null;
    }
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("coachOverview")}</Typography>
      <Box sx={styles.cardsContainer}>
        {candidateDetails.user.overview.map(({ key, title, value }: Overview) => (
          <CandidateOverviewCard key={key} title={title} value={value} icon={getIcon(key)} />
        ))}
      </Box>
    </Box>
  );
};

export default CoachOverview;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
  cardsContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: "8px",
  },
};
